module.exports = __webpack_public_path__ + "static/media/YearPlus.cc6aff54.png";